"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PostpaidAccessoryModalState_1 = require("./PostpaidAccessoryModalState");
var styles = require("./PostpaidAccessoryModal.scss");
var utils_1 = require("@idp/ui-components/utils");
var ReportingService_1 = require("../../../../api/ReportingService");
var components_1 = require("@idp/duc/components");
var UtilityFunctions_1 = require("../../../../utils/UtilityFunctions");
var ui_components_1 = require("@idp/ui-components");
var PostpaidAccessoryModal = /** @class */ (function (_super) {
    __extends(PostpaidAccessoryModal, _super);
    function PostpaidAccessoryModal(props) {
        var _this = _super.call(this, props) || this;
        _this.state = new PostpaidAccessoryModalState_1.default();
        _this.bindFunctions();
        return _this;
    }
    PostpaidAccessoryModal.prototype.bindFunctions = function () {
        this.docEventListener = this.docEventListener.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.renderPopupContent = this.renderPopupContent.bind(this);
        this.renderData = this.renderData.bind(this);
        this.removeEvtListener = this.removeEvtListener.bind(this);
        this.togglePopUp = this.togglePopUp.bind(this);
        this.reportingService = new ReportingService_1.default();
        this.selectionChange = this.selectionChange.bind(this);
    };
    PostpaidAccessoryModal.prototype.componentWillUnmount = function () {
        this.removeEvtListener();
    };
    PostpaidAccessoryModal.prototype.docEventListener = function () {
        document.addEventListener('click', this.handleClick, false);
    };
    PostpaidAccessoryModal.prototype.removeEvtListener = function () {
        document.removeEventListener('click', this.handleClick, false);
    };
    PostpaidAccessoryModal.prototype.handleClick = function (e) {
        if (!(this.popUpWrapper.contains(e.target))) {
            this.togglePopUp(false);
            e.preventDefault();
        }
    };
    PostpaidAccessoryModal.prototype.render = function () {
        var _this = this;
        var _a, _b, _c, _d, _e, _f;
        return (React.createElement("span", { className: styles.marginLeft, "aria-label": "TooltipAccessory", id: utils_1.default('Tooltip', (_b = (_a = this.props) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.elementId), ref: function (node) { _this.popUpWrapper = node; } },
            React.createElement(components_1.Link, { kind: "withAppendIcon", 
                // tslint:disable-next-line: jsx-no-bind
                onClick: this.showPopUp.bind(this), "aria-label": "Quantity Edit " + ((_d = (_c = this.props) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.elementId), className: styles.cartChangeLink, testId: utils_1.default('Quantity', 'Edit', 'Link'), icon: this.state.showPopUp ?
                    React.createElement(components_1.IconSvg, { size: 16, svgNodeStr: UtilityFunctions_1.GET_ICON_SVG.UP }) :
                    React.createElement(components_1.IconSvg, { size: 16, svgNodeStr: UtilityFunctions_1.GET_ICON_SVG.DOWN }) }, this.props.data.linkText),
            this.state.showPopUp &&
                React.createElement("span", { className: styles.container, "aria-label": "Quantity Edit Modal " + ((_f = (_e = this.props) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.elementId) }, this.renderPopupContent())));
    };
    PostpaidAccessoryModal.prototype.showPopUp = function () {
        this.reportingService.fireLinkClickWithOutPageLoad('Edit accessory quantity', ReportingService_1.PageUrls.CART, 'Body');
        this.togglePopUp(true);
    };
    PostpaidAccessoryModal.prototype.renderPopupContent = function () {
        return (React.createElement(React.Fragment, null, this.props && this.props.data &&
            this.props.data.modalData && this.renderData()));
    };
    PostpaidAccessoryModal.prototype.renderData = function () {
        var _this = this;
        var _a;
        var selectedKey = (_a = this.props.data.selected) === null || _a === void 0 ? void 0 : _a.toString();
        return (React.createElement("div", null, this.props.data.modalData.map(function (key, index) {
            var keyId = "quantity" + index;
            var disableDelete = _this.props && _this.props.data &&
                _this.props.data.disableDelete || false;
            var style = (key === selectedKey) ?
                [styles.capacityBoxSmall, styles.active, styles.capacityBtn,
                    (disableDelete) ? styles.accQtyBox : '', (key === 'Delete') ?
                        styles.deleteKeyStyle : ''].join(' ') :
                [styles.capacityBoxSmall, styles.capacityBtn,
                    (disableDelete) ? styles.accQtyBox : '', (key === 'Delete') ?
                        styles.deleteKeyStyle : ''].join(' ');
            var accessibilityText = (key === selectedKey) ? "Current quantity " + key : "quantity " + key;
            return (React.createElement("div", { key: keyId },
                React.createElement(ui_components_1.Button, { data: { text: key }, events: {
                        onClick: function () {
                            _this.selectionChange(key);
                        },
                    }, "aria-label": "Button quantity " + key, options: { className: style, accessibility: accessibilityText }, testId: utils_1.default('Button', "_quantity " + key) })));
        })));
    };
    PostpaidAccessoryModal.prototype.selectionChange = function (key) {
        var _a;
        if (key === 'Delete') {
            key = '0';
        }
        if (key && this.props.data.selected && key !== ((_a = this.props.data.selected) === null || _a === void 0 ? void 0 : _a.toString())) {
            this.props.events.selectionChange(parseInt(key, 10));
            this.setState({ showPopUp: false });
        }
    };
    PostpaidAccessoryModal.prototype.togglePopUp = function (open) {
        var _this = this;
        this.setState({ showPopUp: open }, function () {
            if (_this.state.showPopUp) {
                _this.docEventListener();
            }
            else {
                _this.removeEvtListener();
            }
        });
    };
    return PostpaidAccessoryModal;
}(React.Component));
exports.default = PostpaidAccessoryModal;
//# sourceMappingURL=PostpaidAccessoryModal.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/WirelessCart/PostpaidAccessoryModal/PostpaidAccessoryModal.js
// module id = 420
// module chunks = 8